import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Icon, Button } from 'semantic-ui-react';
import { has, uniqBy, debounce } from 'lodash';
import {
  setViewCurrentStudentHistory,
  fetchStudent,
} from 'PointOfSale/state/actions';
import { isNumeric } from 'Common/GeneralHelper';
import { ViewHistoryModal } from 'PointOfSale/modules/history/component/ViewHistoryModal';
import * as IndividualServingSelectors from 'PointOfSale/modules/individualServing/state/selectors';
import { getSelectedSiteDetailsSiteId } from 'PointOfSale/modules/setDateAndSite/state/selectors';
import { getViewCurrentStudentHistory } from 'PointOfSale/state/selectors';
import * as CommonStateSelectors from 'State/selectors';

import {
  getTransactionHistory,
  clearError,
  postVoidTransaction,
  clearVoidSuccess,
} from 'PointOfSale/modules/history/state/action';
import {
  getTransactionHistoryData,
  getVoidSuccess,
  getTransactionHistoryDataError,
  getViewTransactionHistoryLoading,
  getTransactionHistoryPages,
} from 'PointOfSale/modules/history/state/selectors';
import { errorToast, toastSuccess } from 'Common/ToastHelper';

import { TRANSACTION_HISTORY_TABLE_PAGE_SIZE } from '../../../helpers/Constants';

class HistoryFooterContainer extends React.Component {
  state = { currentPage: 0 };

  componentDidUpdate(prevProps) {
    if (errorToast(this.props, prevProps, 'transactionHistoryDataError')) {
      this.props.clearError();
    }

    if (
      this.props.voidSuccess &&
      this.props.voidSuccess !== prevProps.voidSuccess
    ) {
      toastSuccess('Transaction voided successfully.');
      this.props.clearVoidSuccess();
      this.props.getTransactionHistory(
        this.state.currentPage + 1,
        TRANSACTION_HISTORY_TABLE_PAGE_SIZE,
        [],
        [],
        this.props.idSeed,
        this.props.selectedSite
      );
    }
  }

  getLastBitOfUrl = () => {
    if (has(this.props, 'history.location.pathname')) {
      return this.props.history.location.pathname.split('/').pop();
    } else {
      return '';
    }
  };

  onHistoryClick = () => {
    this.props.setViewCurrentStudentHistory(true);
    this.props.getTransactionHistory(
      1,
      TRANSACTION_HISTORY_TABLE_PAGE_SIZE,
      [],
      [],
      this.props.idSeed,
      this.props.selectedSite
    );
  };

  getFormattedData = (data) => {
    if (data) {
      //build an array of unique transaction id's
      const uniques = uniqBy(data, (x) => x.TransactionId);
      //use the index of the transaction id's to tell if is an odd / even row
      //which determines the color of the row in the grid
      //rows should be grouped by transaction id
      return data.map((transaction, index) => {
        const isOddRow =
          uniques.findIndex(
            (x) => x.TransactionId === transaction.TransactionId
          ) %
            2 !==
          0;
        return { ...transaction, isOddRow };
      });
    }

    return [];
  };

  voidTransaction = async (transactionId) => {
    const { postVoidTransaction, fetchStudent, idSeed } = this.props;
    await postVoidTransaction(transactionId);

    // Update the student after voiding a transaction
    await fetchStudent(idSeed, { fetch: true });
  };

  fetchTransactionHistoryData = (
    pageNumber,
    pageSize,
    sortOptions,
    filterOptions
  ) => {
    const { getTransactionHistory, idSeed, selectedSite } = this.props;
    getTransactionHistory(
      pageNumber,
      pageSize,
      sortOptions,
      filterOptions,
      idSeed,
      selectedSite
    );
  };

  fetchTransactionHistoryDataDebounced = (
    pageNumber,
    pageSize,
    sortOptions,
    filterOptions,
    idSeed,
    selectedSite
  ) => {
    const debouncedFetch = debounce(this.fetchTransactionHistoryData, 50);

    debouncedFetch(
      pageNumber,
      pageSize,
      sortOptions,
      filterOptions,
      idSeed,
      selectedSite
    );
  };

  updatePageNumber = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  render() {
    const id = this.getLastBitOfUrl();
    const showHistory = isNumeric(id);
    const {
      transactionHistoryPages,
      fullName,
      loading,
      online,
      data,
      showModal,
      setViewCurrentStudentHistory,
    } = this.props;

    const { currentPage } = this.state;

    return (
      showHistory && (
        <Fragment>
          <ViewHistoryModal
            showModal={showModal}
            data={this.getFormattedData(data)}
            getData={this.fetchTransactionHistoryDataDebounced}
            setViewCurrentStudentHistory={setViewCurrentStudentHistory}
            postVoidTransaction={this.voidTransaction}
            loading={loading}
            fullName={fullName}
            updatePageNumber={this.updatePageNumber}
            pages={transactionHistoryPages}
            page={currentPage}
          />
          <Button
            fluid
            size="large"
            onClick={this.onHistoryClick}
            color={'grey'}
            disabled={!online}
          >
            <Button.Content>
              <Icon name={'history'} /> History / Void
            </Button.Content>
          </Button>
        </Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    idSeed: IndividualServingSelectors.getProfileIdSeed(state),
    selectedSite: getSelectedSiteDetailsSiteId(state),
    showModal: getViewCurrentStudentHistory(state),
    data: getTransactionHistoryData(state),
    transactionHistoryPages: getTransactionHistoryPages(state),
    voidSuccess: getVoidSuccess(state),
    transactionHistoryDataError: getTransactionHistoryDataError(state),
    loading: getViewTransactionHistoryLoading(state),
    fullName: IndividualServingSelectors.getProfileFullName(state),
    online:
      CommonStateSelectors.getOnline(state) &&
      CommonStateSelectors.getServerUp(state),
  };
};

const mapDispatchToProps = {
  setViewCurrentStudentHistory,
  getTransactionHistory,
  clearError,
  postVoidTransaction,
  clearVoidSuccess,
  fetchStudent,
};

const HistoryFooter = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HistoryFooterContainer)
);

export { HistoryFooter };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/HistoryFooter.js